import React from "react";

export const UpperNav = () => {
  return (
    <div
      className="container-fluid text-white app-bg-dark"
      style={{ paddingTop: "13px", paddingBottom: "13px" }}
    >
      <div className="row">
        <div className="col-md-6 text-center text-md-start upper-nav-text-start">
          <span style={{ fontSize: "15px" }} className="fw-normal">
            Support Days: Entire Week, 9 AM - Midnight
          </span>
        </div>
        <div className="col-md-6 text-center text-md-end upper-nav-text-end ">
          <span style={{ fontSize: "15px" }} className="fw-normal">
            <span className="app-text-primary" style={{ marginRight: "6px" }}>
              Call Us:
            </span>
            <a href="tel:+9221111524246" className="text-white" style={{textDecoration: 'none'}}>+9221-111-524-246</a>
          </span>
        </div>
      </div>
    </div>
  );
};
